var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshcw(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_283_1548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 3.33331V8.33331M19.1667 8.33331H14.1667M19.1667 8.33331L15.3 4.69998C14.4044 3.80391 13.2964 3.14932 12.0793 2.79729C10.8623 2.44527 9.57592 2.40727 8.34024 2.68686C7.10456 2.96645 5.95984 3.55451 5.01289 4.39616C4.06595 5.23782 3.34764 6.30564 2.925 7.49998M0.833336 16.6666V11.6666M0.833336 11.6666H5.83334M0.833336 11.6666L4.7 15.3C5.59562 16.1961 6.70365 16.8506 7.92068 17.2027C9.13771 17.5547 10.4241 17.5927 11.6598 17.3131C12.8954 17.0335 14.0402 16.4455 14.9871 15.6038C15.9341 14.7621 16.6524 13.6943 17.075 12.5",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_283_1548"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshcw);
export default __webpack_public_path__ + "static/media/Refresh cw.92d2ee30a183e9526f463bf73e435442.svg";
export { ForwardRef as ReactComponent };